const ROUTE_LABELS: Array<{ prefix: string; label: string }> = [
  { prefix: "/dashboard", label: "Dashboard" },
  { prefix: "/training/events", label: "Training events" },
  { prefix: "/training/programs", label: "Training center" },
  { prefix: "/members/new", label: "New member" },
  { prefix: "/members/dashboard", label: "Member Dashboard" },
  { prefix: "/members/minds", label: "Minds" },
  { prefix: "/members/xinmiao", label: "Xinmiao" },
  { prefix: "/members", label: "Members" },
  { prefix: "/invoices/new", label: "New invoice" },
  { prefix: "/bonus/accumulated", label: "Bonus Accumulated" },
  { prefix: "/bonus/adjustments", label: "Bonus Adjustment" },
  { prefix: "/bonus/income-tax", label: "Income tax 2%" },
  { prefix: "/bonus/points", label: "Bonus Points" },
  { prefix: "/bonus/report", label: "Bonus Report" },
  { prefix: "/reports/ajl", label: "AJL distributors" },
  { prefix: "/bonus", label: "Bonus" },
  { prefix: "/products/new", label: "New product" },
  { prefix: "/products/dashboard", label: "Dashboard" },
  { prefix: "/products", label: "Products" },
  { prefix: "/stock-in/new", label: "New stock in" },
  { prefix: "/stock-in", label: "Stock In" },
  { prefix: "/issue/new", label: "New issue" },
  { prefix: "/issue", label: "Issue" },
  { prefix: "/loan-out/new", label: "New loan out" },
  { prefix: "/loan-out", label: "Loan Out" },
  { prefix: "/loan-in/new", label: "New loan in" },
  { prefix: "/loan-in", label: "Loan In" },
  { prefix: "/goods-return/new", label: "New goods return" },
  { prefix: "/goods-return", label: "Goods Return" },
  { prefix: "/credit-note/new", label: "New credit note" },
  { prefix: "/credit-note", label: "Credit Note" },
  { prefix: "/write-off/new", label: "New write off" },
  { prefix: "/write-off", label: "Write Off" },
  { prefix: "/branch/new", label: "New branch invoice" },
  { prefix: "/branch", label: "Branch Invoice" },
  { prefix: "/transfer/new", label: "New transfer" },
  { prefix: "/transfer", label: "Transfer" },
  { prefix: "/adjustment/new", label: "New adjustment" },
  { prefix: "/adjustment", label: "Adjustment" },
  { prefix: "/invoices", label: "Invoices" },
  { prefix: "/xmegami-picks", label: "Xmegami Picks" },
  { prefix: "/users/new", label: "New user" },
  { prefix: "/users", label: "Users" },
  { prefix: "/roles", label: "Roles" },
  { prefix: "/settings/product-categories", label: "Product Categories" },
  { prefix: "/settings/payment-modes", label: "Payment Modes" },
  { prefix: "/settings/website-content", label: "Website Content" },
  { prefix: "/settings/countries", label: "Countries" },
  { prefix: "/settings/states", label: "States" },
  { prefix: "/settings/suppliers", label: "Suppliers" },
  { prefix: "/settings/delivery-charges", label: "Delivery Charges" },
  { prefix: "/settings/app-settings", label: "App Settings" },
  { prefix: "/settings/portal-tool-links", label: "Portal Tool Links" },
  { prefix: "/settings/banks", label: "Banks" },
  { prefix: "/settings/maintenance", label: "Maintenance" },
  { prefix: "/change-password", label: "Change Password" },
];

export const ADMIN_SET_TAB_TITLE_EVENT = "admin:set-tab-title";

export function normalizeAdminPath(path: string): string {
  if (!path) return "/dashboard";
  const clean = path.split("?")[0]?.split("#")[0] ?? path;
  if (clean.length > 1 && clean.endsWith("/")) {
    return clean.slice(0, -1);
  }
  return clean;
}

export function isAdminWorkspacePath(path: string): boolean {
  return path !== "/login";
}

export function getAdminTabLabel(path: string): string {
  const clean = normalizeAdminPath(path);
  const matched = ROUTE_LABELS.find((route) => clean === route.prefix || clean.startsWith(`${route.prefix}/`));
  if (matched) return matched.label;
  const segments = clean.split("/").filter(Boolean);
  const tail = segments.at(-1) ?? "Page";
  return tail.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function emitAdminTabTitle(path: string, label: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(ADMIN_SET_TAB_TITLE_EVENT, {
      detail: {
        path: normalizeAdminPath(path),
        label,
      },
    })
  );
}
